export default __webpack_public_path__ + "static/media/cad.335c8bc2.png";